const spacingProps: PropertyKey[] = [
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'marginX',
  'marginY',
  'padding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'paddingX',
  'paddingY',
];

export const isSpacingProp = (prop: PropertyKey) => spacingProps.includes(prop);
export const isNotSpacingProp = (prop: PropertyKey) =>
  !spacingProps.includes(prop);
